<!-- eslint-disable vue/no-unused-vars -->
<template>
    <div class="app-container">
      <!-- 背景图区域 -->
      <div class="kb-header" :style="{ backgroundImage: `url(${knowledgeBase.coverImage})` }">
        <div class="kb-header-overlay">
          <!-- 知识库基本信息 -->
          <div class="kb-info">
            <div class="kb-header-content">
              <h1 class="kb-title">{{ knowledgeBase.name }}</h1>
              <div class="kb-actions">
                <!-- 根据用户角色显示不同的操作按钮 -->
                <template v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                  <!-- 拥有者和编辑者可以编辑 -->
                  <el-button type="primary" icon="el-icon-edit" @click="handleEdit">编辑</el-button>
                  <!-- 拥有者可以管理协作者 -->
                  <el-button v-if="knowledgeBase.userRole === -1" type="primary" icon="el-icon-user" @click="handleCollaborators">协作者</el-button>
                </template>
                <el-button type="primary" icon="el-icon-share" @click="handleShare">分享</el-button>
                <el-button 
                  :type="knowledgeBase.favorited ? 'danger' : 'info'"
                  :icon="knowledgeBase.favorited ?'el-icon-star-on':'el-icon-star-off' "
                  @click="toggleFavorite"
                >
                  {{ knowledgeBase.favorited ? '已收藏' : '收藏' }}
                </el-button>
              </div>
            </div>

            <p class="kb-desc">{{ knowledgeBase.description }}</p>
            
            <div class="kb-meta">
              <!-- 作者信息 -->
              <div class="kb-author">
                <el-avatar :size="28" :src="knowledgeBase.imUserVo?.headImageThumb">
                </el-avatar>
                <span class="author-name">{{ knowledgeBase.imUserVo?.nickName }}</span>
                <span class="create-time">创建于 {{ knowledgeBase.createTime }}</span>
              </div>

              <!-- 统计信息 -->
              <div class="kb-stats">
                <div class="stat-item">
                  <i class="el-icon-document"></i>
                  <span>{{ knowledgeBase.documentCount || 0 }} 篇文档</span>
                </div>
                <div class="stat-item">
                  <i class="el-icon-view"></i>
                  <span>{{ knowledgeBase.viewCount || 0 }} 次浏览</span>
                </div>
                <div class="stat-item">
                  <i class="el-icon-star-off"></i>
                  <span>{{ knowledgeBase.favoriteCount || 0 }} 次收藏</span>
                </div>
              </div>
            </div>

            <!-- 标签 -->
            <div class="kb-tags" v-if="knowledgeBase.tags">
              <el-tag
                v-for="tag in knowledgeBase.tags.split(',')"
                :key="tag"
                size="small"
                effect="plain"
                class="tag-item"
              >
                {{ tag }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>

      <!-- 目录和内容区域 -->
      <div class="kb-main">
        <el-row :gutter="20">
          <!-- 左侧目录树 -->
          <el-col :span="6" :xs="24" style="overflow: auto" :class="{'mobile-directory': isMobile}" v-show="!isMobile || showMobileDirectory">
            <div class="mobile-directory-header" v-if="isMobile">
              <span>目录</span>
              <i class="el-icon-close" @click="showMobileDirectory = false"></i>
            </div>
            <el-card class="kb-directory-card" shadow="never">
              <div slot="header" class="kb-directory-header">
                <div class="kb-directory-header-left">
                  <span>目录</span>
                  <el-button
                    type="text"
                    icon="el-icon-s-home"
                    @click="returnToRoot"
                    title="返回根目录"
                  >根目录</el-button>
                </div>

                  <el-dropdown v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0" trigger="click" @command="(command) => {if(command=='add-dir'){handleAddDirectory()}else{handleAddRootDocument()}}">
                    <el-button
                        type="text"
                        icon="el-icon-plus"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item  command="add-dir" >添加子目录</el-dropdown-item>
                      <el-dropdown-item command="add-doc">添加文档</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>



              </div>
              <div class="kb-directory-search">
                <el-input
                  placeholder="搜索目录和文档"
                  prefix-icon="el-icon-search"
                  v-model="directorySearchText"
                  clearable
                ></el-input>
              </div>
              <div class="kb-directory-tree">
                <el-tree
                  :data="directoryTree"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                  node-key="id"
                  :default-expand-all="false"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  ref="directoryTree"
                  highlight-current
                  class="custom-tree"
                >
                  <span class="kb-tree-node" slot-scope="{ node, data }">
                    <span class="kb-tree-node-label">
                      <i class="el-icon-folder-opened" v-if="!data.isDocument && node.expanded"></i>
                      <i class="el-icon-folder" v-else-if="!data.isDocument && !node.expanded"></i>
                      <i class="el-icon-document" v-else></i>
                      {{ node.label }}
                    </span>
                    <span class="kb-tree-node-actions" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                      <el-dropdown  @command="(command) => handleTreeCommand(command, data)">
                        <i class="el-icon-more"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="!data.isDocument" command="add-dir">添加子目录</el-dropdown-item>
                          <el-dropdown-item v-if="!data.isDocument" command="add-doc">添加文档</el-dropdown-item>
                          <el-dropdown-item v-if="!data.isDocument" command="edit-dir">编辑目录</el-dropdown-item>
                          <el-dropdown-item v-if="data.isDocument" command="edit-doc">编辑文档</el-dropdown-item>
                          <el-dropdown-item divided command="delete">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                  </span>
                </el-tree>
              </div>
            </el-card>
          </el-col>
          
          <!-- 移动端显示目录按钮 -->
          <div class="mobile-directory-toggle" v-if="isMobile">
            <el-button type="primary" icon="el-icon-menu" @click="showMobileDirectory = true"  v-if="!showMobileDirectory">显示目录</el-button>
            <el-button type="primary" icon="el-icon-s-unfold" @click="showMobileOutline = true" v-if="!showMobileOutline &&currentDocument">显示大纲</el-button>
          </div>
          <!-- 右侧内容区 -->
          <el-col :span="18" :xs="24" >
            <el-card class="kb-content-card" shadow="never">
              <div class="kb-content-wrapper">
                <div v-if="currentDocument" class="kb-document">
                  <div class="document-header" >
                    <div class="header-main">
                      <div class="kb-document-path">
                        <i class="el-icon-folder"></i>
                        <span class="kb-path-text">{{ getDocumentPath(currentDocument) }}</span>
                        <i class="el-icon-arrow-right"></i>
                        <i class="el-icon-document"></i>
                      </div>
                      <h2 class="kb-document-title">{{ currentDocument.title }}</h2>
                      <div class="meta">
                        <span class="author">
                           <el-avatar :size="18" :src="currentDocument.imUserVo.headImageThumb">
                  {{ currentDocument.imUserVo.nickName?.charAt(0) }}
                      </el-avatar>
                          {{ currentDocument.imUserVo.nickName }}
                        </span>
                        <span class="date">
                          <i class="el-icon-time"></i>
                          {{ currentDocument.createTime }}
                        </span>
                        <span class="views">
                          <i class="el-icon-view"></i>
                          {{ currentDocument.viewCount || 0 }} 次浏览
                        </span>
                      </div>
                    </div>
                    <div class="header-actions">
                      <el-button-group>
                        <el-button type="primary" size="small" icon="el-icon-share" @click="handleShareDoc(currentDocument)">分享</el-button>
                        <el-button size="small" icon="el-icon-edit" @click="handleEditDocument(currentDocument)" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">编辑</el-button>
                        <el-button size="small" icon="el-icon-delete" type="danger" @click="handleDeleteDocument" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">删除</el-button>
                      </el-button-group>
                    </div>
                  </div>
                  <div class="document-content-wrapper">
                    <div v-if="currentDocument.contentType === 0" class="markdown-body" v-html="renderedMarkdown"></div>
                    <div v-else-if="currentDocument.contentType === 1" class="rich-text-content" >
                      <el-row :gutter="20">
                        <el-col :md="18">
                      <vue-ueditor-wrap v-model="currentDocument.content"
                                        @ready="onChange"
                                        editor-id="editor2"
                                        ref="ueview"
                                        :config="editorConfig2"
                                        :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                      />
                          <comments-section v-if="currentDocument.createBy" bus-type="knowledgeBase" :target-user-id="currentDocument.createBy" :target-id="currentDocument.id"></comments-section>
                        </el-col>
                        <el-col :md="6"  :class="{'mobile-outline': isMobile}" v-show="!isMobile || showMobileOutline">
                          <div class="mobile-directory-header" v-if="isMobile">
                            <span>大纲</span>
                            <i class="el-icon-close" @click="showMobileOutline = false"></i>
                          </div>
                          <div id="directionWrapper" >
                            <div class="directionTitle">目录：</div>
                            <div id="directionContainer" ></div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-else-if="currentDocument.contentType === 2" class="image-content">
                      <img :src="currentDocument.fileUrl" :alt="currentDocument.title" />
                    </div>
                    <div v-else-if="currentDocument.contentType === 3" class="video-content">
                      <video :src="currentDocument.fileUrl" controls></video>
                    </div>
                    <div v-else-if="currentDocument.contentType === 4" class="audio-content">
                      <audio :src="currentDocument.fileUrl" controls></audio>
                    </div>
                    <div v-else-if="currentDocument.contentType === 5" class="file-content">
                      <div class="file-card">
                        <i class="el-icon-document"></i>
                        <div class="file-info">
                          <div class="file-name">{{ currentDocument.title }}</div>
                          <div class="file-size">{{ formatFileSize(currentDocument.fileSize) }}</div>
                        </div>
                        <el-button type="primary" size="small" @click="downloadFile(currentDocument.fileUrl)">下载</el-button>
                      </div>
                    </div>
                    <div v-else-if="currentDocument.contentType === 6" class="link-content">
                      <div class="link-card">
                        <i class="el-icon-link"></i>
                        <div class="link-info">
                          <div class="link-title">{{ currentDocument.title }}</div>
                          <div class="link-url">{{ currentDocument.externalLink }}</div>
                        </div>
                        <el-button type="primary" size="small" @click="openExternalLink(currentDocument.externalLink)">访问</el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="documentOpen"  class="kb-document">
                  <div class="document-header">
                    <div class="header-main">
                      <div class="kb-document-path">
                        <i class="el-icon-folder"></i>
                        <span class="kb-path-text">{{ documentTitle}}</span>
                        <i class="el-icon-arrow-right"></i>
                        <i class="el-icon-document"></i>
                      </div>
                      <h2 class="kb-document-title">
                        <el-input v-model="documentForm.title" placeholder="请输入文档标题" />
                      </h2>
                      <div class="meta" v-if="documentForm.id">
                        <span class="author" >
                           <el-avatar :size="18" :src="documentForm.imUserVo?.headImageThumb">
                  {{ documentForm.imUserVo?.nickName?.charAt(0) }}
                      </el-avatar>
                          {{ documentForm.imUserVo?.nickName }}
                        </span>
                        <span class="date">
                          <i class="el-icon-time"></i>
                          {{ documentForm.updateTime }}
                        </span>
                        <span class="views">
                          <i class="el-icon-view"></i>
                          {{ documentForm.viewCount || 0 }} 次浏览
                        </span>
                      </div>
                    </div>
                    <div class="header-actions" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                      <el-button-group>
                        <el-button size="small" icon="el-icon-check" @click="submitDocumentForm">保存</el-button>
                      </el-button-group>
                    </div>
                  </div>
                  <div class="document-content-wrapper">
                    <el-form ref="documentForm" :model="documentForm" :rules="documentRules" >
<!--                      <el-form-item label="文档标题" prop="title">
                        <el-input v-model="documentForm.title" placeholder="请输入文档标题" />
                      </el-form-item>-->
                      <el-form-item label="排序" prop="sort">
                        <el-input-number v-model="documentForm.sort" :min="0" :max="999" />
                      </el-form-item>
                      <!-- Markdown编辑器 -->
                      <el-form-item label="文档内容" prop="content" v-if="documentForm.contentType === 0">
                        <markdown-editor v-model="documentForm.content" :rows="15" placeholder="请输入Markdown内容"></markdown-editor>
                      </el-form-item>
                      <!-- 富文本编辑器 -->
                      <el-form-item prop="content" v-else-if="documentForm.contentType === 1">
                        <vue-ueditor-wrap v-model="documentForm.content"
                                          editor-id="editor"
                                          ref="ueditor"
                                          :config="editorConfig"
                                          :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                                         />
                      </el-form-item>

                      <!-- 图片上传 -->
                      <el-form-item label="上传图片" prop="fileUrl" v-else-if="documentForm.contentType === 2">
                        <el-upload
                            class="kb-upload"
                            :action="action"
                            :show-file-list="false"
                            :on-success="handleFileSuccess"
                            :before-upload="beforeImageUpload"
                            :on-error="handleUploadError"
                        >
                          <div v-if="documentForm.fileUrl" class="kb-upload-preview">
                            <img :src="documentForm.fileUrl" class="kb-upload-image">
                            <div class="kb-upload-actions">
                              <i class="el-icon-edit"></i>
                            </div>
                          </div>
                          <i v-else class="el-icon-plus kb-upload-icon"></i>
                          <div class="kb-upload-tip">支持 JPG、PNG 格式，最大 10MB</div>
                        </el-upload>
                      </el-form-item>

                      <!-- 视频上传 -->
                      <el-form-item label="上传视频" prop="fileUrl" v-else-if="documentForm.contentType === 3">
                        <el-upload
                            class="kb-upload"
                            :action="action"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleFileSuccess"
                            :before-upload="beforeVideoUpload"
                            :on-error="handleUploadError"
                        >
                          <div v-if="documentForm.fileUrl" class="kb-upload-preview">
                            <video :src="documentForm.fileUrl" controls class="kb-upload-video"></video>
                            <div class="kb-upload-actions">
                              <i class="el-icon-edit"></i>
                            </div>
                          </div>
                          <i v-else class="el-icon-plus kb-upload-icon"></i>
                          <div class="kb-upload-tip">支持 MP4、WebM 格式，最大 100MB</div>
                        </el-upload>
                      </el-form-item>

                      <!-- 音频上传 -->
                      <el-form-item label="上传音频" prop="fileUrl" v-else-if="documentForm.contentType === 4">
                        <el-upload
                            class="kb-upload"
                            :action="action"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleFileSuccess"
                            :before-upload="beforeAudioUpload"
                            :on-error="handleUploadError"
                        >
                          <div v-if="documentForm.fileUrl" class="kb-upload-preview kb-audio-preview">
                            <audio :src="documentForm.fileUrl" controls class="kb-upload-audio"></audio>
                            <div class="kb-upload-actions">
                              <i class="el-icon-edit"></i>
                            </div>
                          </div>
                          <i v-else class="el-icon-plus kb-upload-icon"></i>
                          <div class="kb-upload-tip">支持 MP3、WAV 格式，最大 50MB</div>
                        </el-upload>
                      </el-form-item>

                      <!-- 文件上传 -->
                      <el-form-item label="上传文件" prop="fileUrl" v-else-if="documentForm.contentType === 5">
                        <el-upload
                            class="kb-upload"
                            :action="action"
                            :show-file-list="false"
                            :on-success="handleFileSuccess"
                            :before-upload="beforeFileUpload"
                            :on-error="handleUploadError"
                        >
                          <div v-if="documentForm.fileUrl" class="kb-upload-preview kb-file-preview">
                            <i class="el-icon-document"></i>
                            <span>{{ getFileName(documentForm.fileUrl) }}</span>
                            <div class="kb-upload-actions">
                              <i class="el-icon-edit"></i>
                            </div>
                          </div>
                          <i v-else class="el-icon-plus kb-upload-icon"></i>
                          <div class="kb-upload-tip">支持各种文件格式，最大 100MB</div>
                        </el-upload>
                      </el-form-item>

                      <!-- 外部链接 -->
                      <el-form-item label="外部链接" prop="externalLink" v-else-if="documentForm.contentType === 6">
                        <el-input v-model="documentForm.externalLink" placeholder="请输入外部链接，例如：https://example.com" />
                      </el-form-item>

<!--                      <el-form-item label="状态" prop="status">
                        <el-radio-group v-model="documentForm.status">
                          <el-radio :label="0">草稿</el-radio>
                          <el-radio :label="1">已发布</el-radio>
                        </el-radio-group>
                      </el-form-item>-->
                    </el-form>
                  </div>
                </div>
                <div v-else-if="currentDirectory" class="kb-directory-content">
                  <div class="kb-directory-content-header">
                    <h2 class="kb-directory-title">
                      <i class="el-icon-folder"></i> 
                      <span class="kb-directory-path">
                        {{ getDirectoryPath(currentDirectory) }}
                      </span>
                    </h2>
                    <div class="kb-directory-actions" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddDocumentToCurrentDir">添加文档</el-button>
                      <el-button type="default" size="small" icon="el-icon-edit" @click="handleEditCurrentDir">编辑目录</el-button>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  
                  <!-- 目录下的文档列表 -->
                  <div v-if="directoryDocuments.length > 0" class="kb-document-list">
                    <el-table :data="directoryDocuments" style="width: 100%" @row-click="handleDocumentClick">
                      <el-table-column width="50">
                        <template slot-scope="scope">
                          <i :class="scope.row ? 'el-icon-document' : 'el-icon-document'" style="color: #409EFF;"></i>
                        </template>
                      </el-table-column>
                      <el-table-column prop="title" label="文档标题"></el-table-column>
                      <el-table-column prop="updateTime" label="更新时间" width="180">
                        <template slot-scope="scope">
                          {{ formatDate(scope.row.updateTime) }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="viewCount" label="查看次数" width="100">
                        <template slot-scope="scope">
                          <span><i class="el-icon-view"></i> {{ scope.row.viewCount || 0 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="150" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" @click.stop="handleEditDocument(scope.row)">编辑</el-button>
                          <el-button type="text" size="small" @click.stop="handleDeleteDocument(scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  
                  <!-- 空目录提示 -->
                  <div v-else class="kb-empty-directory">
                    <i class="el-icon-folder-opened"></i>
                    <p>此目录下暂无文档</p>
                    <el-button type="primary" @click="handleAddDocumentToCurrentDir">添加文档</el-button>
                  </div>
                </div>
                <div v-else class="kb-root-content">
                  <div class="kb-root-header">
                    <h2 class="kb-root-title">
                      <i class="el-icon-folder"></i> 根目录
                    </h2>
                    <div class="kb-directory-actions" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddRootDocument">添加文档</el-button>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  
                  <!-- 根目录下的文档列表 -->
                  <div v-if="rootDocuments.length > 0" class="kb-document-list">
                    <el-table :data="rootDocuments" style="width: 100%" @row-click="handleDocumentClick">
                      <el-table-column width="50">
                        <template slot-scope="scope">
                          <i :class="scope.row ? 'el-icon-document' : 'el-icon-document'" style="color: #409EFF;"></i>
                        </template>
                      </el-table-column>
                      <el-table-column prop="title" label="文档标题"></el-table-column>
                      <el-table-column prop="updateTime" label="更新时间" width="180">
                        <template slot-scope="scope">
                          {{ formatDate(scope.row.updateTime) }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="viewCount" label="查看次数" width="100">
                        <template slot-scope="scope">
                          <span><i class="el-icon-view"></i> {{ scope.row.viewCount || 0 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="150" v-if="knowledgeBase.userRole !== null && knowledgeBase.userRole <= 0">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" @click.stop="handleEditDocument(scope.row)">编辑</el-button>
                          <el-button type="text" size="small" @click.stop="handleDeleteDocument(scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  
                  <!-- 空根目录提示 -->
                  <div v-else class="kb-empty-directory">
                    <i class="el-icon-folder-opened"></i>
                    <p>根目录下暂无文档</p>
                    <el-button type="primary" @click="handleAddRootDocument">添加文档</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
    
        <!-- 添加或修改目录对话框 -->
        <el-dialog :title="directoryTitle" :visible.sync="directoryOpen" :width="isMobile?'100%':'550px'" append-to-body>
          <el-form ref="directoryForm" :model="directoryForm" :rules="directoryRules" label-width="80px">
            <el-form-item label="目录名称" prop="name">
              <el-input v-model="directoryForm.name" placeholder="请输入目录名称" />
            </el-form-item>
            <el-form-item label="父目录" prop="parentId">
              <el-select v-model="directoryForm.parentId" placeholder="请选择父目录">
                <el-option label="顶级目录" :value="0" />
                <el-option 
                  v-for="dir in directoryOptions" 
                  :key="dir.id" 
                  :label="dir.name" 
                  :value="dir.id"
                  :disabled="dir.id === directoryForm.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="directoryForm.sort" :min="0" :max="999" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelDirectory">取 消</el-button>
            <el-button type="primary" @click="submitDirectoryForm">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 分享对话框 -->
        <el-dialog title="分享知识库" :visible.sync="shareOpen" :width="isMobile?'100%':'550px'" append-to-body>
          <div class="share-content">
            <div class="share-qrcode">
              <div class="qrcode-wrapper" ref="qrcodeRef"></div>
            </div>
            <div class="share-link">
              <el-input v-model="shareLink" readonly>
                <el-button slot="append" icon="el-icon-copy-document" @click="copyShareLink">复制</el-button>
              </el-input>
            </div>
            <div class="share-tips">
              <p>扫描二维码或复制链接分享给他人</p>
            </div>
          </div>
        </el-dialog>

        <!-- 协作者管理对话框 -->
        <el-dialog
          title="协作者管理"
          :visible.sync="collaboratorDialogVisible"
          :width="isMobile?'100%':'700px'"
          @closed="resetCollaboratorForm"
        >
          <div class="collaborator-container">
            <!-- 协作者列表 -->
            <div class="collaborator-list">
              <div class="list-header">
                <h3>当前协作者</h3>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddCollaborator">添加协作者</el-button>
              </div>
              
              <el-table
                v-loading="collaboratorLoading"
                :data="collaborators"
                style="width: 100%"
                border
              >
                <el-table-column label="用户" min-width="180">
                  <template slot-scope="scope">
                    <div class="collaborators-user-info">
                      <el-avatar :size="36" :src="scope.row.imUserVo?.headImageThumb"></el-avatar>
                      <div class="user-details">
                        <div class="user-name">{{ scope.row.imUserVo?.nickName }}</div>
                        <div class="user-email" v-if="scope.row.imUserVo?.email">{{ scope.row.imUserVo?.email }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                
                <el-table-column label="角色" width="120" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.role === 0 ? 'success' : 'info'" effect="dark">
                      {{ scope.row.role === 0 ? '编辑者' : '查看者' }}
                    </el-tag>
                  </template>
                </el-table-column>
                
                <el-table-column label="添加时间" width="180" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.createTime }}
                  </template>
                </el-table-column>
                
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button type="text" icon="el-icon-edit" @click="handleCollaboratorAction('edit', scope.row)" title="修改角色"></el-button>
                      <el-button type="text" icon="el-icon-delete" @click="handleCollaboratorAction('delete', scope.row)" title="删除"></el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
              
              <!-- 添加分页组件 -->
              <el-pagination
                v-if="collaborators.length > 0"
                @size-change="handleCollaboratorSizeChange"
                @current-change="handleCollaboratorCurrentChange"
                :current-page="collaboratorQuery.pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="collaboratorQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="collaboratorTotal"
                background
                class="pagination-container"
              ></el-pagination>

              <div v-if="collaborators.length === 0" class="empty-block">
                <i class="el-icon-user-solid"></i>
                <p>暂无协作者</p>
                <el-button type="primary" size="small" @click="showAddCollaborator">添加协作者</el-button>
              </div>
            </div>
          </div>
        </el-dialog>

        <!-- 添加协作者对话框 -->
        <el-dialog
          title="添加协作者"
          :visible.sync="addCollaboratorDialogVisible"
          :width="isMobile?'100%':'500px'"
          @closed="resetAddCollaboratorForm"
        >
          <el-form :model="collaboratorForm" ref="collaboratorForm" :rules="collaboratorRules" label-width="80px">
            <el-form-item label="用户" prop="userId">
              <el-input
                v-model="searchKeyword"
                placeholder="搜索用户..."
                @input="searchUsers"
              ></el-input>
              
              <div v-if="searchResults.length > 0" class="search-result">
                <div
                  v-for="user in searchResults"
                  :key="user.id"
                  class="user-item"
                  @click="selectUser(user)"
                >
                  <el-avatar :size="24" :src="user.headImageThumb"></el-avatar>
                  <span>{{ user.nickName }}</span>
                </div>
              </div>
              
              <div v-if="selectedUser" class="selected-user">
                <el-avatar :size="32" :src="selectedUser.headImageThumb"></el-avatar>
                <span>{{ selectedUser.nickName }}</span>
              </div>
            </el-form-item>
            
            <el-form-item label="角色" prop="role">
              <el-radio-group v-model="collaboratorForm.role">
                <el-radio :label="0">编辑者</el-radio>
                <el-radio :label="1">查看者</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          
          <div slot="footer" class="dialog-footer">
            <el-button @click="addCollaboratorDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitCollaborator">确定</el-button>
          </div>
        </el-dialog>

        <!-- 编辑协作者角色对话框 -->
        <el-dialog
          title="编辑协作者角色"
          :visible.sync="editCollaboratorDialogVisible"
          :width="isMobile?'100%':'400px'"
        >
          <el-form :model="collaboratorForm" ref="editCollaboratorForm" label-width="80px">
            <el-form-item label="用户">
              <div class="selected-user">
                <el-avatar :size="32" :src="selectedUser?.headImageThumb"></el-avatar>
                <span>{{ selectedUser?.nickName }}</span>
              </div>
            </el-form-item>
            
            <el-form-item label="角色" prop="role">
              <el-radio-group v-model="collaboratorForm.role">
                <el-radio :label="0">编辑者</el-radio>
                <el-radio :label="1">查看者</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          
          <div slot="footer" class="dialog-footer">
            <el-button @click="editCollaboratorDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEditCollaborator">确定</el-button>
          </div>
        </el-dialog>

        <!-- 付费知识库弹框 -->
        <el-dialog
          title="付费知识库"
          :visible.sync="paymentDialogVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          :width="isMobile?'100%':'400px'"
        >
          <div class="payment-dialog-content">
            <div class="payment-icon">
              <i class="el-icon-lock"></i>
            </div>
            <h3>这是一个付费知识库</h3>
            <p>加入此知识库需要支付 {{ knowledgeBase.price }} 元</p>
            <div class="payment-description" v-if="knowledgeBase.paymentDescription">
              <h4>知识库说明</h4>
              <p>{{ knowledgeBase.paymentDescription }}</p>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handlePayment">立即支付</el-button>
          </div>
        </el-dialog>
      </div>
      <Pay ref="pay" @paySuccess="paySuccess"></Pay>
    </div>
  </template>
  
  <script>

  import CommentsSection from "@/components/common/comments-section.vue";

  var dirmap = {}
  function traversal(section,vm) {
    let list, item, itemContent, child, childList;
    if (section.children && section.children.length > 0) {
      list = document.createElement('ul');
      for (let i = 0; i < section.children.length; i++) {
        child = section.children[i];
        
        // 设置目录节点内容标签
        let title = child['title']; // 使用完整标题
        
        itemContent = document.createElement('div');
        itemContent.classList.add('sectionItem');
        
        let spanTitle = document.createElement('span');
        spanTitle.classList.add('itemTitle');
        spanTitle.textContent = title;
        
        // 添加点击事件
        spanTitle.addEventListener('click', function() {
          vm.showMobileOutline=false;
          // 获取编辑器实例
          const editor = window.UE.getEditor('editor2');
          if (editor && editor.ready) {
            // 滚动到对应位置
             var   address = this.parentNode.getAttribute('data-address');
            editor.execCommand('selectsection', dirmap[address], true);
            console.log(dirmap[address].dom.id,dirmap)
            // 获取编辑器 iframe
            const editorIframe = document.getElementsByTagName('iframe')[0];
            if (editorIframe && editorIframe.contentWindow) {
              // 获取选中的元素
              const selection = editorIframe.contentWindow.document.getElementById(dirmap[address].dom.id);
              // 平滑滚动到选中元素
              selection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            // editor.execCommand('scrollIntoView', false, dirmap[address].dom.id);
            // 高亮当前点击的项
            const allItems = document.querySelectorAll('.sectionItem');
            allItems.forEach(item => item.classList.remove('active'));
            this.parentNode.classList.add('active');
          }
        });
        
        itemContent.appendChild(spanTitle);
        itemContent.dataset.address = child['startAddress'].join(',');
        
        dirmap[child['startAddress'].join(',')] = child;
        
        // 设置目录节点容器标签
        item = document.createElement('li');
        item.appendChild(itemContent);
        
        // 继续遍历子节点
        if (child.children && child.children.length > 0) {
          childList = traversal(child,vm);
          if (childList) {
            item.appendChild(childList);
          }
        }
        
        list.appendChild(item);
      }
    }
    return list;
  }
  
 
  function getSubStr(s, l) {
    let i = 0, len = 0;
    for (i; i < s.length; i++) {
      // 使用 Unicode 属性转义来匹配非 ASCII 字符
      if (/[^\p{ASCII}]/u.test(s.charAt(i))) {
        len += 2;
      } else {
        len++;
      }
      if (len > l) {
        break;
      }
    }
    return s.substr(0, i);
  }
  import { getKnowledgeBase, getKnowledgeBaseDetail, updateViewCount } from "@/api/knowledgeBase/knowledgeBase";
  import { listDirectory, getDirectory, delDirectory, addDirectory, updateDirectory } from "@/api/knowledgeBase/directory";
  import { listDocument, getDocument, delDocument, addDocument, updateDocument,listDocumentsByDirectory } from "@/api/knowledgeBase/document";
  import MarkdownEditor from '@/components/MarkdownEditor';
  import MarkdownIt from 'markdown-it';
  import hljs from 'highlight.js';
  import 'highlight.js/styles/github.css';
  import QRCode from "qrcodejs2";
  import { listCollaborators, addCollaborator, updateCollaborator, delCollaborator } from '@/api/knowledgeBase/collaborator';
  import { toggleFavorite, checkFavorite } from '@/api/knowledgeBase/favorite';
  import Pay from "@/components/common/Pay.vue";
  import VueUeditorWrap from 'vue-ueditor-wrap'
  export default {
    name: "KnowledgeBaseDetail",
    components: {
      CommentsSection,
      Pay,
      VueUeditorWrap,
      MarkdownEditor
    },

    data() {
      return {
        dir:'',
        editorConfig: {
          loadConfigFromServer:false,
          // 后端服务地址，后端处理参考
          // https://open-doc.modstart.com/ueditor-plus/backend.html
          serverUrl: process.env["VUE_APP_BASE_API2"]+'/ueditor/controller',
          UEDITOR_HOME_URL: '/static/UEditorPlus/',
          UEDITOR_CORS_URL: '/static/UEditorPlus/',
        },
        editorConfig2: {
          loadConfigFromServer:false,
          serverUrl:process.env["VUE_APP_BASE_API2"]+'/ueditor/controller',
          UEDITOR_HOME_URL: '/static/UEditorPlus/',
          UEDITOR_CORS_URL: '/static/UEditorPlus/',
          readonly:true,
          toolbars:[],
          enableContextMenu:false,
        },
        action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
        qrcode: null,
        // 知识库ID
        knowledgeBaseId: null,
        // 知识库详情
        knowledgeBase: {},
        // 目录树
        directoryTree: [],
        // 目录选项（用于下拉选择）
        directoryOptions: [],
        // 当前选中的文档
        currentDocument: null,
        // 当前目录
        currentDirectory: null,
        // 目录下的文档列表
        directoryDocuments: [],
        // 默认属性
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        // 目录搜索文本
        directorySearchText: '',
        // 目录对话框标题
        directoryTitle: "",
        // 目录对话框是否显示
        directoryOpen: false,
        // 目录表单参数
        directoryForm: {
          id: null,
          knowledgeId: null,
          parentId: 0, // 默认为顶级目录
          name: "",
          sort: 0
        },
        // 目录表单校验
        directoryRules: {
          name: [
            { required: true, message: "目录名称不能为空", trigger: "blur" }
          ]
        },
        // 文档对话框标题
        documentTitle: "",
        // 文档对话框是否显示
        documentOpen: false,
        // 文档表单参数
        documentForm: {
          id: null,
          knowledgeId: null,
          directoryId: null,
          title: null,
          content: null,
          contentType: 1,
          fileUrl: "",
          fileSize: null,
          fileType: "",
          externalLink: "",
          status: 0,
          sort: 0
        },
        // 文档表单校验
        documentRules: {
          title: [
            { required: true, message: "文档标题不能为空", trigger: "blur" }
          ],
          directoryId: [
            { required: true, message: "所属目录不能为空", trigger: "change" }
          ],
          content: [
            { required: true, message: "文档内容不能为空", trigger: "blur" }
          ]
        },
        // 分享对话框是否显示
        shareOpen: false,
        // 分享链接
        shareLink: '',
        // 分享二维码
        shareQrCode: '',
        // 上传文件的请求头
        headers: {
          Authorization: 'Bearer ' + (sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"))
        },
        // 初始化markdown-it
        md: new MarkdownIt({
          html: true,
          linkify: true,
          typographer: true,
          highlight: function(str, lang) {
            if (lang && hljs.getLanguage(lang)) {
              try {
                return hljs.highlight(lang, str).value;
              } catch (error) {
                console.error('Error highlighting code:', error);
              }
            }
            return ''; // 使用默认的转义
          }
        }),
        // 添加根目录文档列表
        rootDocuments: [],
        // 协作者管理相关
        collaboratorDialogVisible: false,
        addCollaboratorDialogVisible: false,
        editCollaboratorDialogVisible: false,
        collaboratorLoading: false,
        collaborators: [],
        collaboratorForm: {
          id: null,
          knowledgeId: null,
          userId: null,
          role: 1 // 默认为查看者
        },
        collaboratorRules: {
          userId: [
            { required: true, message: '请选择用户', trigger: 'change' }
          ],
          role: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ]
        },
        searchKeyword: '',
        searchResults: [],
        selectedUser: null,
        currentCollaborator: null,
        collaboratorQuery: {
          knowledgeId: null,
          pageNum: 1,
          pageSize: 10
        },
        collaboratorTotal: 0,
        paymentDialogVisible:false,
        isMobile: false,
        showMobileDirectory: false,
        showMobileOutline: false
      };
    },
    computed: {
      renderedMarkdown() {
        return this.currentDocument && this.currentDocument.content
          ? this.md.render(this.currentDocument.content)
          : '';
      }
    },
    watch: {
      directorySearchText(val) {
        this.$refs.directoryTree.filter(val);
      }
    },
    created() {
      this.knowledgeBaseId = this.$route.params.id;
      this.getKnowledgeBaseDetail();
      this.updateViewCount();
      if(this.$route.query.id)
        setTimeout(()=>{
          this.loadDocument(this.$route.query.id)
        },1000)
      this.checkDeviceType();
      window.addEventListener('resize', this.checkDeviceType);
      this.loadUploadConfig();
    },
    mounted() {
      // 确保编辑器正确初始化
      if (this.$refs.weditor) {
        this.$refs.weditor.initEditor()
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkDeviceType);
    },
    methods: {
      async loadUploadConfig() {
        try {
          // 路径说明：
          // - 开发环境：/configs/ueditor-upload.json 对应 public/configs/ueditor-upload.json
          // - 生产环境：构建后会复制到 dist/configs/ueditor-upload.json，路径不变
          const response = await fetch(this.editorConfig.serverUrl+'?action=config');
          const uploadConfig = await response.json();
          // 合并配置
          this.editorConfig = {
            ...this.editorConfig,
            ...uploadConfig
          };
          this.editorConfig2 = {
            ...this.editorConfig2,
            ...uploadConfig
          };
        } catch (error) {
          console.error('加载上传配置失败：', error);
        }
      },
     async paySuccess(mchOrderNo){
        console.log("支付成功，",mchOrderNo)
        this.collaboratorForm.knowledgeId=this.knowledgeBaseId;
        this.collaboratorForm.userId=this.userStore.userInfo.id
        const res = await addCollaborator(this.collaboratorForm);
        if (res.code === 200) {
          this.$message.success('成为协作者成功');
          this.getKnowledgeBaseDetail();
        } else {
          this.$message.error(res.msg || '成为协作者失败');
        }
      },
      // 修改构建目录树的方法，添加文档节点
      buildDirectoryTree() {
        if (!this.knowledgeBase || !this.knowledgeBase.directories) {
          this.directoryTree = [];
          return;
        }
        // 深拷贝目录树，避免修改原始数据
        this.directoryTree = JSON.parse(JSON.stringify(this.knowledgeBase.directories));
        // 查询所有文档
        listDocument({ knowledgeId: this.knowledgeBaseId }).then(response => {
          const documents = response.rows || [];
          // 将文档添加到对应的目录中
          this.addDocumentsToTree(this.directoryTree, documents);
        });
      },

      // 递归将文档添加到目录树中
      addDocumentsToTree(directories, documents) {
        if (!directories || !documents) return;

        directories.forEach(directory => {
          // 筛选出当前目录下的文档
          const directoryDocuments = documents.filter(doc => doc.directoryId === directory.id);

          // 如果目录没有children属性，初始化为空数组
          if (!directory.children) {
            directory.children = [];
          }

          // 将文档转换为树节点并添加到目录的children中
          directoryDocuments.forEach(doc => {
            directory.children.push({
              id: doc.id,
              name: doc.title,
              isDocument: true,
              directoryId: directory.id,
              // 可以添加其他需要的文档属性
            });
          });
          // 递归处理子目录
          if (directory.children) {
            const childDirectories = directory.children.filter(child => !child.isDocument);
            this.addDocumentsToTree(childDirectories, documents);
          }
        });
      },
      onChange(editor) {
        console.log('onChange',editor);
     /*   setTimeout(()=>{
          this.$refs.ueview.editor.render('editor2', {
            autoFloatEnabled: false
          })
        },1000)*/
      },
      /** 获取知识库详情 */
      getKnowledgeBaseDetail() {
        getKnowledgeBaseDetail(this.knowledgeBaseId).then(response => {
          this.knowledgeBase = response.data;
          if(this.knowledgeBase.userRole==3) this.paymentDialogVisible=true
          this.directoryTree = response.data.directories || [];
          this.buildDirectoryTree()
          this.buildDirectoryOptions(this.directoryTree);
          // 加载根目录文档
          this.loadRootDocuments(true);
          if(this.currentDirectory){
            setTimeout(()=> {
              this.expandToNode(this.currentDirectory.id)
              this.$refs.directoryTree.setCurrentKey(this.currentDirectory.id);
            }, 1000);
          }else if(this.currentDocument){
            setTimeout(()=> {
              this.expandToNode(this.currentDocument.directoryId)
              this.$refs.directoryTree.setCurrentKey(this.currentDocument.id);
            }, 1000);
          }
        });
      },
      /** 构建目录选项（用于下拉选择） */
      buildDirectoryOptions(directories, parentPath = '') {
        this.directoryOptions = [];
        this.flattenDirectories(directories, parentPath);
      },
      /** 将目录树扁平化为选项数组 */
      flattenDirectories(directories, parentPath = '') {
        if (!directories || directories.length === 0) return;
        
        directories.forEach(dir => {
          const currentPath = parentPath ? `${parentPath} / ${dir.name}` : dir.name;
          this.directoryOptions.push({
            id: dir.id,
            name: currentPath
          });
          
          if (dir.children && dir.children.length > 0) {
            this.flattenDirectories(dir.children, currentPath);
          }
        });
      },
      /** 过滤节点 */
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      /** 返回上一页 */
      goBack() {
        this.$router.push('/knowledgeBase');
      },
      /** 处理树节点点击 */
      handleNodeClick(data) {
        console.log("handleNodeClick",data)
        if (data.isDocument) {
          // 如果点击的是文档，则加载文档内容
          this.loadDocument(data.id);
          this.currentDirectory = null;
        } else {
          // 如果点击的是目录，则显示目录内容
          this.currentDocument = null;
          this.loadDirectoryContent(data);
        }
        this.documentOpen=false;
        // 移动端点击后自动隐藏目录
        if (this.isMobile) {
          this.showMobileDirectory = false;
        }
      },
      /** 处理树节点命令 */
      handleTreeCommand(command, data) {
        switch (command) {
          case 'add-dir':
            this.handleAddSubDirectory(data);
            break;
          case 'add-doc':
            this.handleAddDocument(data);
            break;
          case 'edit-dir':
            this.handleEditDirectory(data);
            break;
          case 'edit-doc':
            this.handleEditDocument(data);
            break;
          case 'delete':
            if (data.isDocument) {
              this.handleDeleteDocument(data);
            } else {
              this.handleDeleteDirectory(data);
            }
            break;
        }
      },
      /** 新增目录 */
      handleAddDirectory() {
        this.resetDirectoryForm();
        this.directoryForm.knowledgeId = this.knowledgeBaseId;
        this.directoryOpen = true;
        this.currentDirectory=null;
        this.directoryTitle = "添加目录";
      },
      /** 修改目录 */
      handleEditDirectory(data) {
        this.resetDirectoryForm();
        getDirectory(data.id).then(response => {
          this.directoryForm = response.data;
          this.directoryOpen = true;
          this.directoryTitle = "修改目录";
        });
      },
      /** 删除目录 */
      handleDeleteDirectory(data) {
        this.$confirm('是否确认删除目录"' + data.name + '"？删除后将无法恢复，且会删除该目录下的所有文档。', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return delDirectory(data.id);
        }).then(() => {
          this.getKnowledgeBaseDetail();
          this.$message.success("删除成功");
        }).catch(() => {});
      },
      /** 取消目录按钮 */
      cancelDirectory() {
        this.directoryOpen = false;
        this.resetDirectoryForm();
      },
      /** 重置目录表单 */
      resetDirectoryForm() {
        this.directoryForm = {
          id: null,
          knowledgeId: this.knowledgeBaseId,
          parentId: 0,
          name: "",
          sort: 0
        };
        
        // 手动重置表单
        if (this.$refs.directoryForm) {
          this.$refs.directoryForm.resetFields();
        }
      },
      /** 提交目录表单 */
      submitDirectoryForm() {
        this.$refs["directoryForm"].validate(valid => {
          if (valid) {
            if (this.directoryForm.id != null) {
              updateDirectory(this.directoryForm).then(response => {
                this.$message.success("修改成功");
                this.directoryOpen = false;
                this.getKnowledgeBaseDetail();
              });
            } else {
              addDirectory(this.directoryForm).then(response => {
                this.$message.success("新增成功");
                this.directoryOpen = false;
                this.getKnowledgeBaseDetail();
              });
            }
          }
        });
      },
      /** 新增子目录文档 */
      handleAddDocument(directory) {
        this.resetDocumentForm();
        this.documentForm.knowledgeId = this.knowledgeBaseId;
        this.documentForm.directoryId = directory.id;
        this.documentOpen = true;
        this.currentDocument=null;
        this.documentTitle = "添加文档";
      },
      /** 修改文档 */
      handleEditDocument(doc) {
        this.resetDocumentForm();
        getDocument(doc.id).then(response => {
          this.documentForm = response.data;
          this.documentOpen = true;
          this.currentDocument=null;
          this.documentTitle = "修改文档";
        });
      },
      /** 删除文档按钮操作 */
      handleDeleteDocument(row) {
        const documentId = row.id || (this.currentDocument ? this.currentDocument.id : null);
        if (!documentId) return;
        
        this.$confirm('是否确认删除该文档?', "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          return delDocument(documentId);
        }).then(() => {
          this.$message.success("删除成功");
          
          // 如果删除的是当前查看的文档，清空当前文档
          if (this.currentDocument && this.currentDocument.id === documentId) {
            this.currentDocument = null;
          }
          
          // 刷新知识库详情，更新目录树
          this.getKnowledgeBaseDetail();
          
          // 如果当前有选中的目录，刷新该目录下的文档列表
          if (this.currentDirectory) {
            this.loadDirectoryContent(this.currentDirectory);
          }
        }).catch(() => {});
      },
      /** 取消文档按钮 */
      cancelDocument() {
        this.documentOpen = false;
        this.resetDocumentForm();
      },
      /** 重置文档表单 */
      resetDocumentForm() {
        this.documentForm = {
          id: null,
          knowledgeId: null,
          directoryId: null,
          title: null,
          content: null,
          contentType: 1,
          fileUrl: "",
          fileSize: null,
          fileType: "",
          externalLink: "",
          status: 0,
          sort: 0
        };
        
        // 手动重置表单
        if (this.$refs.documentForm) {
          this.$refs.documentForm.resetFields();
        }
      },
      /** 提交文档表单 */
      submitDocumentForm() {
        this.$refs["documentForm"].validate(valid => {
          if (valid) {
            // 提交表单
            if (this.documentForm.id != null) {
              updateDocument(this.documentForm).then(response => {
                this.$message.success("修改成功");
                this.documentOpen = false;
                this.getKnowledgeBaseDetail();
                
                // 如果修改的是当前查看的文档，重新加载文档
                  this.loadDocument(this.documentForm.id);
                // 如果当前有选中的目录，刷新该目录下的文档列表
                if (this.currentDirectory) {
                  this.loadDirectoryContent(this.currentDirectory);
                }
              });
            } else {
              addDocument(this.documentForm).then(response => {
                this.$message.success("新增成功");
                this.documentOpen = false;
                this.getKnowledgeBaseDetail();
                
                // 如果当前有选中的目录，刷新该目录下的文档列表
                if (this.currentDirectory && this.documentForm.directoryId === this.currentDirectory.id) {
                  this.loadDirectoryContent(this.currentDirectory);
                }
              });
            }
          }
        });
      },
      /** 处理分享 */
      handleShare() {
        this.shareLink =process.env.VUE_APP_SHARE_BASE + '/#/knowledgeBase/detail/' + this.knowledgeBaseId;
        // 生成二维码，这里可以使用第三方库如 qrcode.js
        this.generateQrCode(this.shareLink);
      },
      handleShareDoc(doc) {
        this.shareLink =process.env.VUE_APP_SHARE_BASE + '/#/knowledgeBase/detail/' + this.knowledgeBaseId+"?id="+doc.id;
        // 生成二维码，这里可以使用第三方库如 qrcode.js
        this.generateQrCode(this.shareLink);
      },
      /** 生成二维码 */
      generateQrCode(url) {
        this.$nextTick(() => {
        this.$refs.qrcodeRef.innerHTML = ''
      new QRCode(this.$refs.qrcodeRef, {
          text: url,
          width: 150,
          height: 150,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        })
        this.shareOpen = true;
      },
      /** 复制分享链接 */
      copyShareLink() {
        const input = document.createElement('input');
        input.value = this.shareLink;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('链接已复制到剪贴板');
      },
      /** 格式化日期 */
      formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('zh-CN', { 
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        }).replace(/\//g, '-');
      },
      /** 格式化文件大小 */
      formatFileSize(size) {
        if (!size) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let i = 0;
        while (size >= 1024 && i < units.length - 1) {
          size /= 1024;
          i++;
        }
        return Math.round(size * 100) / 100 + ' ' + units[i];
      },
      /** 下载文件 */
      downloadFile(url) {
        if (!url) return;
        const a = document.createElement('a');
        a.href = url;
        a.download = this.currentDocument.title || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      /** 打开外部链接 */
      openExternalLink(url) {
        if (!url) return;
        window.open(url, '_blank');
      },
      /** 处理文件上传成功 */
      handleFileSuccess(response, file) {
        if (response.code === 200) {
          this.documentForm.fileUrl = response.data.originUrl;
          this.documentForm.fileSize = file.size;
          this.documentForm.fileType = file.type;
          this.$message.success('文件上传成功');
        } else {
          this.$message.error('文件上传失败');
        }
      },
      /** 上传前检查 */
      beforeFileUpload(file) {
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
          this.$message.error('文件大小不能超过 50MB!');
          return false;
        }
        return true;
      },
      /** 添加一个方法来展开指定的节点 */
      expandNode(key) {
        console.log("展开节点，",key)
        console.log("节点，",this.$refs.directoryTree.store.nodesMap)
        if(key!=0)
        this.$refs.directoryTree.store.nodesMap[key].expanded = true;
      },
      /** 添加一个方法来展开到指定的节点 */
      expandToNode(nodeId) {
        // 首先直接展开当前节点
        this.expandNode(nodeId);
        
        // 获取节点的路径
        const node = this.$refs.directoryTree.store.nodesMap[nodeId];
        if (node) {
          // 展开所有父节点
          let parent = node.parent;
          while (parent && parent.data && !Array.isArray(parent.data)) {
            if (parent.data.id) {
              this.expandNode(parent.data.id);
            }
            parent = parent.parent;
          }
          
          // 确保节点可见（滚动到视图）
          this.$nextTick(() => {
            const el = document.querySelector(`[data-key="${nodeId}"]`);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
        }
      },
      /**
       * 加载文档目录
       */
      loadDocumentDir(){
        setTimeout(()=>{
          console.log( this.dir)
          let elementById = document.getElementById('directionContainer');
          while (elementById.firstChild) {
            elementById.removeChild(elementById.firstChild);
          }
          elementById.appendChild(traversal(this.$refs.ueview.editor.execCommand('getsections'),this))
        },1000)
      },
      /** 在加载文档时展开到文档所在的目录 */
      loadDocument(id) {
        getDocument(id).then(response => {
          this.currentDocument = response.data;
          this.loadDocumentDir();
          if(this.knowledgeBase.userRole==3) this.paymentDialogVisible=true
          // 展开到文档所在的目录
          if (this.currentDocument.directoryId) {
            this.expandToNode(this.currentDocument.directoryId);
          }
          this.$refs.directoryTree.setCurrentKey(this.currentDocument.id);
        });
      },
      /** 加载目录内容 */
      loadDirectoryContent(directory) {
        this.currentDirectory = directory;
        this.directoryDocuments = [];
        
        // 调用API获取目录下的文档列表
        listDocumentsByDirectory(directory.id, this.knowledgeBaseId).then(response => {
          this.directoryDocuments = response.rows || [];
        }).catch(error => {
          console.error("获取目录文档失败:", error);
          this.$message.error("获取目录文档失败");
        });
      },
      /** 处理文档点击 */
      handleDocumentClick(row) {
        this.loadDocument(row.id);
      },
      /** 添加文档到当前目录 */
      handleAddDocumentToCurrentDir() {
        if (this.currentDirectory) {
          this.resetDocumentForm();
          this.documentForm.knowledgeId = this.knowledgeBaseId;
          this.documentForm.directoryId = this.currentDirectory.id;
          this.documentOpen = true;
          this.documentTitle = "添加文档";
        }
      },
      /** 编辑当前目录 */
      handleEditCurrentDir() {
        if (this.currentDirectory) {
          this.resetDirectoryForm();
          this.directoryForm = { ...this.currentDirectory };
          this.directoryOpen = true;
          this.directoryTitle = "修改目录";
        }
      },
      /** 添加获取目录路径的方法 */
      getDirectoryPath(directory) {
        if (!directory) return '';
        
        // 构建路径数组
        const pathArray = [];
        let currentDir = directory;
        
        // 添加当前目录
        pathArray.unshift(currentDir.name);
        
        // 递归添加父目录
        this.addParentToPath(currentDir.parentId, pathArray);
        
        // 返回格式化的路径
        return pathArray.join(' / ');
      },
      
      // 递归添加父目录到路径
      addParentToPath(parentId, pathArray) {
        if (!parentId || parentId === 0) return;
        
        // 在目录树中查找父目录
        const findParent = (tree, id) => {
          for (const node of tree) {
            if (node.id === id) return node;
            if (node.children && node.children.length > 0) {
              const found = findParent(node.children, id);
              if (found) return found;
            }
          }
          return null;
        };
        
        const parent = findParent(this.directoryTree, parentId);
        if (parent) {
          pathArray.unshift(parent.name);
          this.addParentToPath(parent.parentId, pathArray);
        }
      },
      /** 添加获取文档路径的方法 */
      getDocumentPath(document) {
        if (!document) return '';
        
        // 获取文档所属目录
        const directoryId = document.directoryId;
        if (!directoryId) return '根目录';
        
        // 构建路径数组
        const pathArray = [];
        
        // 递归添加父目录
        this.addParentToPath(directoryId, pathArray);
        
        // 返回格式化的路径
        return pathArray.join(' / ');
      },
      /** 添加处理添加子目录的方法 */
      handleAddSubDirectory(parentDirectory) {
        this.resetDirectoryForm();
        this.directoryForm.knowledgeId = this.knowledgeBaseId;
        this.directoryForm.parentId = parentDirectory.id; // 设置父目录ID
        this.directoryOpen = true;
        this.directoryTitle = "添加子目录";
      },
      /** 添加在根目录下添加文档的方法 */
      handleAddRootDocument() {
        this.resetDocumentForm();
        this.documentForm.knowledgeId = this.knowledgeBaseId;
        this.documentForm.directoryId = 0; // 设置为根目录
        this.documentOpen = true;
        this.currentDocument=null;
        this.documentTitle = "添加文档";
      },
      // 加载根目录文档
      loadRootDocuments(add) {
        // 查询根目录下的文档
        listDocumentsByDirectory(0, this.knowledgeBaseId).then(response => {
          this.rootDocuments = response.rows || [];
          if(add){
            // 将根目录文档添加到目录树的顶层
            const rootDocuments = this.rootDocuments.map(doc => ({
              id: doc.id,
              name: doc.title,
              isDocument: true,
              directoryId: 0,
              // 可以添加其他需要的文档属性
            }));
            // 将根目录文档添加到目录树中
            this.directoryTree = [...rootDocuments,...this.directoryTree];
          }
        }).catch(error => {
          console.error("获取根目录文档失败:", error);
          this.$message.error("获取根目录文档失败");
        });
      },
      /** 添加返回根目录的方法 */
      returnToRoot() {
        // 清空当前选中的目录和文档
        this.currentDirectory = null;
        this.currentDocument = null;
        this.documentOpen=false;
        // 取消树中的选中状态
        if (this.$refs.directoryTree) {
          this.$refs.directoryTree.setCurrentKey(null);
        }

      },
      updateViewCount() {
        updateViewCount(this.knowledgeBaseId).then(response => {
        }).catch(() => {
          this.$message.error("查看次数更新失败");
        });
      },
      // 打开协作者管理对话框
      handleCollaborators() {
        this.collaboratorDialogVisible = true;
        // 重置分页参数
        this.collaboratorQuery.pageNum = 1;
        this.loadCollaborators();
      },
      
      // 加载协作者列表
      async loadCollaborators() {
        this.collaboratorLoading = true;
        try {
          // 确保设置了知识库ID
          this.collaboratorQuery.knowledgeId = this.knowledgeBase.id;
          
          const res = await listCollaborators(this.collaboratorQuery);
          if (res.code === 200) {
            this.collaborators = res.rows;
            this.collaboratorTotal = res.total;
          } else {
            this.$message.error(res.msg || '获取协作者列表失败');
          }
        } catch (error) {
          console.error('获取协作者列表失败', error);
          this.$message.error('获取协作者列表失败');
        } finally {
          this.collaboratorLoading = false;
        }
      },
      
      // 显示添加协作者对话框
      showAddCollaborator() {
        this.addCollaboratorDialogVisible = true;
        this.collaboratorForm = {
          knowledgeId: this.knowledgeBase.id,
          userId: null,
          role: 1
        };
        this.selectedUser = null;
        this.searchKeyword = '';
        this.searchResults = [];
      },
      
      // 搜索用户
      async searchUsers() {
        if (!this.searchKeyword.trim()) {
          this.searchResults = [];
          return;
        }
        
        try {
          const res = await this.$http2.get('/im/user/list', {
            params: {
              nickName: this.searchKeyword,
              pageNum: 1,
              pageSize: 10
            }
          });
          
          if (res.code === 200) {
            // 过滤掉已经是协作者的用户和知识库创建者
            this.searchResults = res.rows.filter(user => {
              const isCreator = user.id === this.knowledgeBase.createBy;
              const isCollaborator = this.collaborators.some(c => c.userId === user.id);
              return !isCreator && !isCollaborator;
            });
          }
        } catch (error) {
          console.error('搜索用户失败', error);
        }
      },
      
      // 选择用户
      selectUser(user) {
        this.selectedUser = user;
        this.collaboratorForm.userId = user.id;
        this.searchResults = [];
        this.searchKeyword = '';
      },
      
      // 提交添加协作者
      submitCollaborator() {
        this.$refs.collaboratorForm.validate(async valid => {
          if (valid) {
            try {
              const res = await addCollaborator(this.collaboratorForm);
              if (res.code === 200) {
                this.$message.success('添加协作者成功');
                this.addCollaboratorDialogVisible = false;
                this.loadCollaborators();
              } else {
                this.$message.error(res.msg || '添加协作者失败');
              }
            } catch (error) {
              console.error('添加协作者失败', error);
              this.$message.error('添加协作者失败');
            }
          }
        });
      },
      
      // 处理协作者操作
      handleCollaboratorAction(command, row) {
        this.currentCollaborator = row;
        
        if (command === 'edit') {
          this.editCollaboratorDialogVisible = true;
          this.collaboratorForm = {
            id: row.id,
            knowledgeId: row.knowledgeId,
            userId: row.userId,
            role: row.role
          };
          this.selectedUser = row.imUserVo;
        } else if (command === 'delete') {
          this.deleteCollaborator(row);
        }
      },
      
      // 提交编辑协作者
      async submitEditCollaborator() {
        try {
          const res = await updateCollaborator(this.collaboratorForm);
          if (res.code === 200) {
            this.$message.success('修改协作者角色成功');
            this.editCollaboratorDialogVisible = false;
            this.loadCollaborators();
          } else {
            this.$message.error(res.msg || '修改协作者角色失败');
          }
        } catch (error) {
          console.error('修改协作者角色失败', error);
          this.$message.error('修改协作者角色失败');
        }
      },
      
      // 删除协作者
      deleteCollaborator(row) {
        this.$confirm('确认删除该协作者吗？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const res = await delCollaborator(row.id);
            if (res.code === 200) {
              this.$message.success('删除协作者成功');
              this.loadCollaborators();
            } else {
              this.$message.error(res.msg || '删除协作者失败');
            }
          } catch (error) {
            console.error('删除协作者失败', error);
            this.$message.error('删除协作者失败');
          }
        }).catch(() => {});
      },
      
      // 重置协作者表单
      resetCollaboratorForm() {
        this.collaboratorForm = {
          id: null,
          knowledgeId: null,
          userId: null,
          role: 1
        };
        this.selectedUser = null;
      },
      
      // 重置添加协作者表单
      resetAddCollaboratorForm() {
        if (this.$refs.collaboratorForm) {
          this.$refs.collaboratorForm.resetFields();
        }
        this.selectedUser = null;
        this.searchKeyword = '';
        this.searchResults = [];
      },
      
      // 编辑知识库
      handleEdit() {
        // 跳转到编辑页面，并传递知识库ID
        this.$router.push({
          name: 'KnowledgeBaseEdit',
          params: { id: this.knowledgeBase.id }
        });
      },
      
      // 收藏/取消收藏知识库
      async toggleFavorite() {
        try {
          const res = await toggleFavorite(this.knowledgeBase.id);
          if (res.code === 200) {
            // 更新收藏状态
            this.knowledgeBase.favorited = !this.knowledgeBase.favorited;
            
            // 更新收藏数量
            if (this.knowledgeBase.favorited) {
              this.knowledgeBase.favoriteCount = (this.knowledgeBase.favoriteCount || 0) + 1;
              this.$message.success('收藏成功');
            } else {
              this.knowledgeBase.favoriteCount = Math.max((this.knowledgeBase.favoriteCount || 0) - 1, 0);
              this.$message.success('已取消收藏');
            }
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        } catch (error) {
          console.error('收藏操作失败', error);
          this.$message.error('操作失败，请稍后重试');
        }
      },
      
      // 在getDetail方法中添加检查收藏状态的代码
      async checkFavorite() {
        try {
          // ... 现有的代码
          
          // 检查是否已收藏
          const favoriteRes = await checkFavorite(this.knowledgeBase.id);
          if (favoriteRes.code === 200) {
            this.knowledgeBase.favorited = favoriteRes.data;
          }
          
          // ... 现有的代码
        } catch (error) {
          // ... 现有的代码
        }
      },
      handleCollaboratorSizeChange(size) {
        this.collaboratorQuery.pageSize = size;
        this.loadCollaborators();
      },
      handleCollaboratorCurrentChange(page) {
        this.collaboratorQuery.pageNum = page;
        this.loadCollaborators();
      },
      handleBack() {
        this.paymentDialogVisible = false;
      },
      handlePayment() {
        // 处理支付逻辑
        this.paymentDialogVisible = false;
        this.$refs.pay.openPay(this.knowledgeBaseId,"knowledgeBase");
      },
      // 检测设备类型
      checkDeviceType() {
        this.isMobile = window.innerWidth <= 768;
        // 移动端默认隐藏目录和大纲
        if (this.isMobile) {
          this.showMobileDirectory = false;
          this.showMobileOutline = false;
        }
      }
     
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .app-container {
    //height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  
  .kb-header {
    position: relative;
    height: 180px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  
  .kb-header-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.5));
    padding: 30px 0;
  }
  
  .kb-info {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
    color: #fff;

    .kb-header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .kb-title {
        margin: 0;
        font-size: 24px;
        line-height: 1.3;
        font-weight: 500;
      }

      .kb-actions {
        .el-button {
          border: none;
          background: rgba(255,255,255,0.2);
          &:hover {
            background: rgba(255,255,255,0.3);
          }
        }
      }
    }

    .kb-desc {
      margin: 0 0 16px;
      font-size: 13px;
      line-height: 1.5;
      opacity: 0.9;
    }

    .kb-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .kb-author {
      display: flex;
      align-items: center;
      gap: 6px;

      .author-name {
        font-size: 13px;
        font-weight: 500;
      }

      .create-time {
        opacity: 0.8;
        font-size: 12px;
      }
    }

    .kb-stats {
      display: flex;
      gap: 20px;

      .stat-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        opacity: 0.9;

        i {
          font-size: 14px;
        }
      }
    }

    .kb-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;

      .tag-item {
        background: rgba(255,255,255,0.15);
        border: none;
        color: #fff;
        height: 22px;
        line-height: 20px;
        padding: 0 8px;
        font-size: 12px;
      }
    }
  }
  
  .kb-main {
    flex: 1;
    padding: 20px;
    background: #f6f8fa;
    overflow: hidden;
  }
  
  .kb-content-card {
    height: 100%;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }
  }
  
  .kb-content-wrapper {
    //height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  .kb-detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .kb-directory-card, .kb-content-card {
    //height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
  }
  
  .kb-directory-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .kb-directory-header-left {
    display: flex;
    align-items: center;
  }
  
  .kb-directory-header-left span {
    margin-right: 10px;
  }
  
  .kb-directory-search {
    margin-bottom: 15px;
  }
  
  .kb-directory-tree {
    height: 100%;
    overflow: auto;
    
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }
  }
  
  .custom-tree {
    background: transparent;
    color: #333;
  }
  
  .custom-tree >>> .el-tree-node__content {
    height: 36px;
    border-radius: 4px;
    transition: all 0.3s;
  }
  
  .custom-tree >>> .el-tree-node__content:hover {
    background-color: #f0f7ff;
  }
  
  .custom-tree >>> .el-tree-node.is-current > .el-tree-node__content {
    background-color: #e6f2ff;
    color: #409EFF;
  }
  
  .custom-tree >>> .el-tree-node__expand-icon {
    font-size: 16px;
    color: #909399;
  }
  
  .custom-tree >>> .el-tree-node__expand-icon.expanded {
    transform: rotate(90deg);
  }
  
  .custom-tree >>> .el-tree-node__expand-icon.is-leaf {
    color: transparent;
  }
  
  .kb-tree-node {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .kb-tree-node-label {
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  
  .kb-tree-node-label i {
    margin-right: 8px;
    font-size: 16px;
  }
  
  .kb-tree-node-label i.el-icon-folder {
    color: #e6a23c;
  }
  
  .kb-tree-node-label i.el-icon-folder-opened {
    color: #e6a23c;
  }
  
  .kb-tree-node-label i.el-icon-document {
    color: #409EFF;
  }
  
  .kb-tree-node-actions {
    display: none;
    margin-left: 10px;
  }
  
  .kb-tree-node:hover .kb-tree-node-actions {
    display: block;
  }
  
  .kb-tree-node-actions i {
    font-size: 14px;
    color: #909399;
    cursor: pointer;
  }
  
  .kb-tree-node-actions i:hover {
    color: #409EFF;
  }
  
  .kb-document {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .document-header {
    padding: 12px 20px;
    border-bottom: 1px solid #eee;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
  }
  
  .header-main {
    flex: 1;
    min-width: 0; /* 防止文本溢出 */
    
    .title {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      color: #333;
      line-height: 1.4;
      margin-bottom: 4px;
    }
    
    .meta {
      display: flex;
      align-items: center;
      color: #909399;
      font-size: 13px;
      
      span {
        display: flex;
        align-items: center;
        margin-right: 16px;
        
        i {
          margin-right: 4px;
          font-size: 14px;
        }
      }
    }
  }
  
  .header-actions {
    margin-left: 16px;
  }
  
  .document-content-wrapper {
    //flex: 1;
    overflow-y: auto;
    background: #fff;
  }
  
  .file-card, .link-card {
    display: flex;
    align-items: center;
    padding: 20px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #f5f7fa;
  }
  
  .file-card i, .link-card i {
    font-size: 32px;
    color: #409EFF;
    margin-right: 15px;
  }
  
  .file-info, .link-info {
    flex: 1;
  }
  
  .file-name, .link-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  
  .file-size, .link-url {
    font-size: 14px;
    color: #909399;
  }
  
  .image-content {
    text-align: center;
    
    img {
      max-width: 100%;
      height: auto;
    }
  }
  
  .video-content video, .audio-content audio {
    width: 100%;
  }
  
  .share-content {
    text-align: center;
    padding: 20px 0;
  }
  
  .share-qrcode {
    margin-bottom: 20px;
    :deep(img) {
      margin: 0 auto;
    }
  }
  
  .share-qrcode img {
    width: 200px;
    height: 200px;
  }
  
  .share-link {
    margin-bottom: 15px;
  }
  
  .share-tips {
    color: #909399;
    font-size: 14px;
  }
  
  .markdown-body {
    padding: 0 20px;
  }
  
  .rich-text-content {
    height: 100%;
    
    :deep(.w-e-text-container) {
      height: 100% !important;
    }
  }
  
  /* 隐藏编辑器工具栏和状态栏 */
  :deep(.w-e-toolbar),
  :deep(.w-e-bar) {
    display: none !important;
  }
  
  .kb-directory-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .kb-directory-content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .kb-directory-title {
    margin: 0;
    font-size: 24px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  
  .kb-directory-title i {
    margin-right: 10px;
    color: #e6a23c;
  }
  
  .kb-directory-actions {
    display: flex;
    gap: 10px;
  }
  
  .kb-document-list {
    flex: 1;
    overflow-y: auto;
  }
  
  .kb-empty-directory {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    color: #909399;
  }
  
  .kb-empty-directory i {
    font-size: 64px;
    color: #e6a23c;
    margin-bottom: 20px;
  }
  
  /* 修改目录路径样式 */
  .kb-directory-path {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  /* 添加文档路径样式 */
  .kb-document-path {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #909399;
    margin-bottom: 10px;
  }
  
  .kb-document-path i {
    margin: 0 5px;
  }
  
  .kb-document-path i.el-icon-folder {
    color: #e6a23c;
  }
  
  .kb-document-path i.el-icon-document {
    color: #409EFF;
  }
  
  .kb-path-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  /* 添加内容头部样式 */
  .kb-content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  /* 添加根目录内容样式 */
  .kb-root-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .kb-root-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .kb-root-title {
    margin: 0;
    font-size: 24px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  
  .kb-root-title i {
    margin-right: 10px;
    color: #e6a23c;
  }
  
  .editor-container {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    
    :deep(.w-e-toolbar) {
      border-bottom: 1px solid #dcdfe6;
      padding: 5px;
    }

    :deep(.w-e-text-container) {
      height: 450px !important;
    }

    :deep(.w-e-text-container [contenteditable='true']) {
      min-height: 400px !important;
    }

    :deep(.w-e-toolbar),
    :deep(.w-e-text-container) {
      background-color: #fff;
    }

    :deep(.w-e-toolbar) {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      z-index: 10;
    }

    :deep(.w-e-bar-item) {
      display: flex;
      padding: 4px 6px;
      cursor: pointer;
      
      &:hover {
        background-color: #f5f7fa;
      }
    }

    :deep(.w-e-bar-divider) {
      border-left: 1px solid #dcdfe6;
      margin: 0 5px;
    }
  }

  /* 确保编辑器容器有足够的高度 */
  .editor-container {
    min-height: 400px;
    margin-bottom: 20px;
  }

  /* 修复菜单栏可能被遮挡的问题 */
  :deep(.w-e-toolbar) {
    z-index: 2 !important;
    background-color: #fff;
  }

  /* 确保编辑区域正常显示 */
  :deep(.w-e-text-container) {
    z-index: 1;
  }

  .collaborator-container {
    padding: 20px;
  }

  .collaborator-list {
    margin-bottom: 20px;
  }

  .list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .selected-user {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .empty-block {
    text-align: center;
    color: #909399;
  }

  /* 协作者管理样式 */
  .collaborator-container {
    .list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      h3 {
        margin: 0;
        font-size: 16px;
        color: #303133;
      }
    }
    
    .collaborators-user-info {
      display: flex;
      align-items: center;
      
      .user-details {
        margin-left: 12px;
        
        .user-name {
          font-weight: 500;
          color: #303133;
          line-height: 1.4;
        }
        
        .user-email {
          font-size: 12px;
          color: #909399;
        }
      }
    }
    
    .empty-block {
      text-align: center;
      padding: 40px 0;
      color: #909399;
      background-color: #f5f7fa;
      border-radius: 4px;
      margin-top: 20px;
      
      i {
        font-size: 48px;
        margin-bottom: 10px;
        color: #dcdfe6;
      }
      
      p {
        margin-bottom: 15px;
      }
    }
    
    :deep(.el-table) {
      margin-bottom: 20px;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    }
    
    :deep(.el-table__header-wrapper) {
      th {
        background-color: #f5f7fa;
        color: #606266;
        font-weight: 600;
      }
    }
    
    :deep(.el-button-group) {
      .el-button {
        padding: 6px 8px;
        
        &:hover {
          color: #409EFF;
        }
        
        &:last-child:hover {
          color: #F56C6C;
        }
      }
    }

    /* 在协作者管理样式中添加分页样式 */
    .pagination-container {
      margin-top: 15px;
      margin-bottom: 15px;
      display: flex;
      justify-content: flex-end;
    }
  }

  // 添加协作者表单样式
  .search-result {
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-top: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .user-item {
      padding: 10px 15px;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-bottom: 1px solid #ebeef5;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover {
        background-color: #f5f7fa;
      }
      
      span {
        margin-left: 12px;
        font-weight: 500;
      }
    }
  }

  .selected-user {
    margin-top: 15px;
    padding: 12px 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    background-color: #f5f7fa;
    
    span {
      margin-left: 12px;
      font-weight: 500;
      color: #303133;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .payment-dialog-content {
    text-align: center;
    padding: 20px 0;
    
    .payment-icon {
      font-size: 60px;
      color: #E6A23C;
      margin-bottom: 20px;
    }
    
    h3 {
      font-size: 18px;
      color: #303133;
      margin-bottom: 15px;
    }
    
    p {
      color: #606266;
      margin-bottom: 20px;
    }
    
    .payment-description {
      text-align: left;
      background-color: #f5f7fa;
      border-radius: 4px;
      padding: 15px;
      margin-top: 20px;
      
      h4 {
        font-size: 14px;
        color: #303133;
        margin-bottom: 10px;
      }
      
      p {
        font-size: 13px;
        color: #606266;
        line-height: 1.6;
        margin-bottom: 0;
      }
    }
  }
  .directionWrapper {
    padding: 15px 7px;
    width: 234px;
    border: 1px solid #CCC;
    max-height: 500px;
    overflow-y: auto;
  }
  ::v-deep ul {
    margin: 0px;
    padding: 0px 0px 0px 10px;
    list-style: none;
  }
  ::v-deep .directionTitle {
    font-weight: bold;
    font-size: 14px;
    padding-bottom: 3px;
    border-bottom: 1px dashed #ccc;
    margin-bottom: 8px;
  }

  ::v-deep .sectionItem {
    height: auto;
    min-height: 20px;
    padding: 4px;
    margin: 2px 0;
    border-left: 2px solid transparent;
    transition: all 0.2s ease;
  }

  ::v-deep .sectionItem:hover {
    background-color: #f5f5f5;
    border-left: 2px solid #409EFF;
  }

  ::v-deep  .itemTitle {
    cursor: pointer;
    display: inline-block;
  }

  /* 不同层级的缩进和样式 */
  ::v-deep #directionContainer > ul > li > .sectionItem {
    font-weight: bold;
  }

  ::v-deep #directionContainer > ul > li > ul > li > .sectionItem {
    font-weight: normal;
    color: #333;
  }

  ::v-deep #directionContainer > ul > li > ul > li > ul > li > .sectionItem {
    font-weight: normal;
    color: #666;
    font-size: 13px;
  }

  /* 添加层次指示符 */
  ::v-deep #directionContainer ul li .sectionItem::before {
    content: "•";
    display: inline-block;
    margin-right: 5px;
    color: #409EFF;
  }

  ::v-deep #directionContainer ul li ul li .sectionItem::before {
    content: "○";
    color: #67C23A;
  }

  ::v-deep #directionContainer ul li ul li ul li .sectionItem::before {
    content: "▪";
    color: #E6A23C;
    font-size: 10px;
  }

  /* 美化滚动条 */
  ::v-deep #directionWrapper::-webkit-scrollbar {
    width: 4px;
  }

  ::v-deep #directionWrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::v-deep #directionWrapper::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  ::v-deep #directionWrapper::-webkit-scrollbar-thumb:hover {
    background: #999;
  }

  ::v-deep .sectionItem.active {
    background-color: #ecf5ff;
    border-left: 2px solid #409EFF;
    font-weight: bold;
  }

  /* 移动端目录样式 */
  .mobile-directory {
    position: fixed;
    top: 0;
    left: 0;
    width: 80%;
    height: 100%;
    background-color: white;
    z-index: 1000;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
  }

  .mobile-directory-header,
  .mobile-outline-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    
    span {
      font-size: 18px;
      font-weight: bold;
    }
    
    i {
      font-size: 20px;
      cursor: pointer;
    }
  }

  .mobile-directory-toggle,
  .mobile-outline-toggle {
    margin: 10px 0;
    text-align: center;
  }
  
  /* 移动端大纲样式 */
  .mobile-outline {
    position: fixed;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    background-color: white;
    z-index: 1000;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
  }

  @media screen and (max-width: 768px) {
    .kb-directory-card {
      margin-top: 0;
      border: none;
      box-shadow: none !important;
    }
    
    .kb-directory-tree {
      max-height: calc(100vh - 180px);
    }
    
    .kb-header {
      height: 250px;
    }
    
    .document-outline {
      margin-top: 0;
      border: none;
      box-shadow: none !important;
    }
    
    .outline-content {
      max-height: calc(100vh - 180px);
    }
    .kb-main{
      padding: 0;
    }
  }
  </style>
